import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { SignupForm } from '.';
import { IUserSignUpResponse } from '@gik/api/users/auth';
import ExternalLoginForm from '@gik/auth/components/ExternalLogin/ExternalLoginForm';

const blockName = 'signup-section';

export interface ISignupSectionProps {
  buttonsPortal?: () => HTMLElement;
  onSuccess?: (doneResponse: IUserSignUpResponse) => void | Promise<void>;
  onLogin?: () => void;
}

export default function SignupSection({ buttonsPortal, onSuccess, onLogin }: ISignupSectionProps) {
  const bem = bemBlock(blockName);

  return (
    <section className={bem()}>
      <ExternalLoginForm signup />
      <SignupForm buttonsPortal={buttonsPortal} onSuccess={onSuccess} onLogin={onLogin} />
    </section>
  );
}
